import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { Content as InputSaveContainer } from '../../../../components/InputSave/style';
import { ButtonToolbar as ActionButtonContainer } from '../../../../components/ActionBtn/style';
import { getIsDraggingStyle } from '../../style';

export const RowProduct = styled.div`
  border-top: 1px solid ${styles.colors.GRAY_LIGHT};
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  height: 76px;
  padding: 0 13px 0 30px;

  ${({ isDragging }) => getIsDraggingStyle(isDragging)}

  .product-image-4all {
    flex-shrink: 0;
    margin-left: ${({ isDragging }) => (isDragging ? '0' : '43px')};

    .product-image-4all__text {
      display: none;
    }
  }

  &:focus {
    outline: none;
  }

  ${InputSaveContainer} {
    margin-right: 55px;
  }

  ${ActionButtonContainer} {
    margin-left: 48px;
  }
`;

export const ProductDetails = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  ${({ isDragging }) => isDragging && 'width: 100%;'}

  .checkbox-4all {
    margin-bottom: 0;
    ${({ isDragging }) => isDragging && 'display: none;'}

    > span:first-child {
      margin-right: 0;
    }
  }
`;

export const ProductName = styled.p`
  ${({ disabled }) =>
    mixins.fontStyle(
      disabled ? styles.colors.GRAY_MEDIUM_3 : styles.colors.GRAY_DARKER,
      styles.fontSizes.SIZE_5,
      styles.fontWeights.SEMIBOLD
    )};
  margin: 0 0 0 14px;
`;

export const ProductActions = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })};
  ${({ isDragging }) => isDragging && 'display: none;'}
`;



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/ProductItem/style.js